// Auto-refactored from translations.js on 2026-08-19
// Locale: fr

const fr = {
  wieMoeglich: {
    question: 'Comment est-ce possible ?',
    answer: 'Nous avons repensé la chaîne de valeur.'
  },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'La voie STIG ROCK',
    fazit: "La chaîne d'approvisionnement raccourcie élimine les plus grands postes de coûts.",
    fazitBigPre: "Cela permet une remise allant jusqu'à",
    fazitBigValue: '80%',
    steps: [ 'Mine', 'Atelier de taille', 'Certification', 'Client final' ]
  },
  nav: { language: 'Langue', contact: 'Contact' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Une opportunité unique',
    subtitle: "Bâtir un patrimoine tourné vers l'avenir.",
    description: 'STIG ROCK est une plateforme internationale offrant aux investisseurs un accès aux diamants naturels, à la constitution de patrimoine durable et à une communauté exclusive.',
    scroll: 'Faites défiler pour découvrir'
  },
  disclaimer: {
    overline: 'Avis juridique',
    title: 'Disclaimer',
    paragraphs: [
      "Cette présentation est fournie à titre informatif uniquement et ne constitue pas un conseil financier, d'investissement ou fiscal.",
      "STIG ROCK n'est pas un produit financier, mais se réfère aux diamants naturels en tant qu'actifs tangibles.",
      "Aucune garantie n'est donnée quant à l'évolution de la valeur, aux gains ou aux rendements. Les performances passées ne sont pas une indication des résultats futurs.",
      'Tous les calculs présentés en relation avec les commissions sont purement exemplaires et ne constituent également aucune garantie.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'BÂTI SUR', 'UNE STRUCTURE' ],
    body: 'STIG Group est un groupe international fondé sur la clarté, la responsabilité et la valeur à long terme. Chaque marque, chaque projet et chaque Partner suit un standard unique — sans raccourcis, sans exceptions.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'BÂTI SUR', 'UNE STRUCTURE' ],
        body: 'STIG Group est un groupe international fondé sur la clarté, la responsabilité et la valeur à long terme. Chaque marque, chaque projet et chaque Partner suit un standard unique — sans raccourcis, sans exceptions.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'LE MONDE DES', 'DIAMANTS EXCLUSIFS' ],
        body: 'STIG ROCK est un concept moderne du STIG Group, alliant des diamants certifiés GIA de haute qualité à des structures transparentes et une expérience client exclusive. Des plans de solutions clairs, une exécution professionnelle et une orientation internationale.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'COMMERCE INTERNATIONAL', 'DE DIAMANTS' ],
        body: 'Stig International fait partie du STIG Group et se spécialise dans le commerce international de diamants certifiés GIA. Focus sur la qualité, la confiance et des structures commerciales modernes avec des partenariats mondiaux.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'RESPONSABILITÉ', 'DÈS LA MINE' ],
        body: "Ethical Mines incarne l'extraction responsable, l'origine traçable et les diamants sans conflit. De la mine au marché — une documentation complète pour la transparence, l'intégrité et la responsabilité à long terme tout au long de la chaîne d'approvisionnement."
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamants',
    stigDrawback: 'Réserve de valeur réelle',
    overline: 'Possibilités',
    title: 'Possibilités de constitution de patrimoine',
    subtitle: 'Comparaison des voies conventionnelles.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex ou Crypto',
        drawback: 'hautement spéculatif, imprévisible, complexe'
      },
      {
        tag: 'Actions',
        name: 'Bourse',
        drawback: 'risque de fluctuation, connaissances requises, temps nécessaire'
      },
      {
        tag: 'Crypto',
        name: 'Commerce',
        drawback: 'volatilité, risque réglementaire, failles de sécurité'
      }
    ]
  },
  chance: {
    overline: 'Diamants',
    title: "L'opportunité sous-estimée",
    body: "Depuis des années, les diamants comptent parmi les formes d'investissement les plus stables et les plus prometteuses, pourtant peu de gens ont exploité ce potentiel jusqu'à présent.",
    callout: "Avec notre STIG ROCK, nous ouvrons pour la première fois l'accès à ces opportunités exceptionnelles pour tous."
  },
  wertentwicklung: {
    overline: 'Évolution de la valeur 1995 — 2025',
    title: 'Une histoire de valeur.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamanten',
    diamondValue: '+185%',
    note: 'Évolution de 1995 à 2025'
  },
  hauptgruende: {
    overline: 'Raisons principales',
    title: 'Six raisons pour les diamants',
    lead: 'Les diamants sont des actifs tangibles réels qui existent indépendamment des devises et des systèmes financiers — et conservent leur valeur depuis des siècles.',
    items: [
      {
        n: '01',
        title: 'Stabilité de valeur anticrise',
        body: "Garantie d'actif tangible. Indépendant des devises et des systèmes financiers."
      },
      {
        n: '02',
        title: 'La mobilité ultime',
        body: 'Petit, facile à dissimuler et à transporter.'
      },
      {
        n: '03',
        title: 'Diversification & Rareté',
        body: "Pénuries d'approvisionnement et limitation naturelle."
      },
      { n: '04', title: 'Croissance à long terme', body: '+185% depuis 1995.' },
      {
        n: '05',
        title: 'Transparence & Exclusivité',
        body: 'Les 4 Cʼs comme garantie : Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Réserve des familles royales',
        body: 'Même les têtes couronnées utilisent les diamants comme réserve de patrimoine.'
      }
    ]
  },
  markt: {
    overline: 'Volume du marché',
    title: '99 — 108 Mrd. USD',
    sub: 'Volume des échanges en 2025',
    forecast: "Prévisions jusqu'à ~2032 / 2034 : env. 140 – 168 Mrd. USD avec une croissance modérée (~4 – 5 % p.a.).",
    source: 'Source : Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovation',
    title: 'Une innovation. Pour la première fois au monde.',
    body: "STIG ROCK est la première plateforme mondiale permettant aux individus de générer un revenu passif sur le marché des diamants, en plus de l'appréciation de la valeur.",
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'N° de registre DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: "À propos de l'entreprise",
    titleLines: [ 'STRUCTURE', 'INTERNATIONALE', 'VISION CLAIRE' ],
    body: 'STIG ROCK a été fondé pour rendre le marché du diamant plus transparent, moderne et orienté client — avec un focus sur la confiance, la sécurité et une structure à long terme.'
  },
  sicherheit: {
    overline: 'Qualité & Sécurité',
    title: 'Gemological Institute of America',
    body: 'Expertise certifiée pour vos diamants. La GIA évalue chaque pierre avec la plus haute précision et une expérience de longue date — des expertises de valeur fiables pour notre entreprise et nos clients.',
    transparency: 'Chaque diamant répond aux standards de qualité les plus élevés et est contrôlé et certifié par des organisations renommées. Chaque pierre est unique et reçoit un certificat individuel.'
  },
  plaene: {
    overline: 'Solution Plans (SP)',
    title: 'Une innovation produit unique',
    sub: 'Six Solution Plans échelonnés — de $1K à $100K+, chacun avec une remise croissante par mois et sur toute la durée.',
    recommended: 'Populaire',
    oneYear: '1 an',
    rowLabels: {
      delivery: 'Délai de livraison',
      price: 'Prix du produit',
      carat: 'Carat',
      monthly: 'Remise (mois)',
      totalDiscount: 'Remise (totale)',
      duration: 'Durée'
    },
    headers: {
      plan: 'Plan',
      from: 'Dès',
      carat: 'Carat',
      monthly: 'Remise / mois',
      total: 'Remise Totale',
      duration: 'Durée'
    },
    duration: '1 an',
    footnote: "Toutes les indications de prix sont sans engagement et dépendent de la qualité, de la demande et de l'évolution actuelle du marché. Les plans Solution sont également possibles pour 2 ans."
  },
  plaeneVIP: {
    overline: 'Solution Plans + Pack VIP',
    title: "Plus d'avantages avec le VIP-Paket",
    sub: "Combine ton Solution Plan avec un VIP-Paket et profite d'avantages tarifaires supplémentaires allant jusqu'à 3 %. Tu augmentes ainsi ta remise globale et t'assures des conditions encore plus attractives.",
    rowLabels: {
      delivery: 'Délai de livraison',
      price: 'Prix du produit',
      carat: 'Carat',
      monthly: 'Remise (mois)',
      totalDiscount: 'Remise (totale)',
      vip1: 'Pack VIP 1 (+1%)',
      vip2: 'Pack VIP 2 (+2%)',
      vip3: 'Pack VIP 3 (+3%)'
    },
    footnote: "Toutes les indications de prix sont sans engagement et dépendent de la qualité, de la demande et de l'évolution actuelle du marché."
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: "Plus d'avantages avec le VIP-Paket",
    sub: "Combine ton Solution Plan avec un VIP-Paket et profite d'avantages tarifaires supplémentaires allant jusqu'à 3 %. Tu augmentes ainsi ta remise globale et t'assures des conditions encore plus attractives.",
    options: [
      {
        key: 'deliver',
        title: "Plus d'avantages avec le VIP-Paket",
        body: 'Diamants (Carat) au prix de votre DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Nous vendre',
        body: "Vous pouvez nous revendre vos diamants au prix d'achat que vous avez payé."
      },
      {
        key: 'sellThirdParty',
        title: 'Vendre à des tiers',
        body: 'Vous pouvez revendre vos diamants à des tiers.'
      }
    ],
    footnote: '*DS-Plan signifie Solution Plan.'
  },
  tradWeg: {
    overline: 'Commerce traditionnel',
    title: 'Le parcours traditionnel',
    sub: "Avant qu'un diamant n'atteigne le client final, des marges commerciales considérables sont générées par les intermédiaires, les grossistes et les détaillants, par rapport au prix du diamant brut à la mine.",
    steps: [
      { title: 'Mine', subtitle: 'Diamants bruts' },
      { title: 'Intermédiaire', subtitle: 'Achat de diamants bruts' },
      { title: 'Atelier de taille', subtitle: 'Taille en diamants de joaillerie' },
      { title: 'Certification', subtitle: 'par des instituts reconnus comme GIA' },
      { title: 'Bourse du diamant', subtitle: 'Vente au gros' },
      { title: 'Grossiste', subtitle: 'Vente au détail' },
      { title: 'Détaillant', subtitle: 'par ex. bijoutiers' },
      { title: 'Clients finaux', subtitle: 'Achat de diamants' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Packs VIP',
    sub: 'Valable 12 mois sur tous vos plans Solution souscrits. Selon le pack VIP : +1% à +3% de remise supplémentaire',
    cardKicker: 'supplémentaire – sur tous les',
    cardKicker2: 'Solution Plans',
    tip: 'Recommendation: VIP package 3 becomes most attractive from $2,800 upward.',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Les remises deviennent des économies',
      body: "Économie mensuelle au lieu d'une charge mensuelle. Les remises génèrent des économies — et celles-ci financent précisément les choses que vous payez normalement chaque mois de votre poche.",
      line1Label: 'DS-Plan dès',
      line1Value: '$5.000',
      line2Label: 'remise mens.',
      line2Value: '3%',
      line3Label: 'Pack VIP 3',
      line3Value: '+3%',
      resultLabel: 'économies mens.',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Comment est-ce possible ?',
    title: 'Nous avons repensé la chaîne de valeur.',
    traditionalTitle: 'Le parcours traditionnel',
    traditionalSteps: [
      'Mine — Diamants bruts',
      'Intermédiaire — Achat',
      'Atelier de taille — Taille',
      'Certification (GIA)',
      'Bourse du diamant — Commerce de gros',
      'Grossiste → Détaillant',
      'Bijoutiers → Client final'
    ],
    traditionalNote: "Avant qu'un diamant n'atteigne le client final, des marges commerciales considérables sont générées par les intermédiaires, les grossistes et les détaillants.",
    stigTitle: 'Le parcours STIG ROCK',
    stigSteps: [
      'Achat direct — Diamants bruts de la mine',
      'Taille & certification par nos Partners',
      'Vente aux clients finaux & clients B2B',
      "Jusqu'à 4 cycles commerciaux par an"
    ],
    stigNote: "Nous brisons le cycle et reversons les marges commerciales à nos clients sous forme de crédits de remise — jusqu'à 4 cycles commerciaux pendant la durée du DS-Plan."
  },
  optionen: {
    overline: 'Vos possibilités',
    title: 'Après expiration de votre Solution Plan',
    items: [
      { title: 'Se faire livrer', body: 'Diamants (Carat) au prix de votre DS-Plan.' },
      { title: 'Nous vendre', body: "Rachat au prix d'achat que vous avez payé." },
      { title: 'Vendre à des tiers', body: 'Céder les diamants sur le marché libre.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution Plans — une innovation produit unique',
    title: 'La voie simple',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Inscription',
        body: 'Contactez votre recommandeur et créez un compte gratuit !'
      },
      {
        n: '02',
        icon: 'cart',
        title: "Achat d'un produit",
        body: 'Déjà à partir de $ 250,-'
      },
      {
        n: '03',
        icon: 'discount',
        title: 'Recevoir des remises',
        body: 'Recevez des crédits de remise mensuels.'
      }
    ]
  },
  business: {
    overline: 'Types de bonus',
    title: 'La voie la plus simple et la plus équitable.',
    sub: 'Cinq types de bonus — pour la réussite de votre développement commercial.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: "Jusqu'au niveau 3, dès le rang Pearl / Ruby."
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Dès Sapphire — profondeur infinie.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: "Sur l'Infinity Bonus – jusqu'au niveau 5 · SANS qualification."
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: "3 pools sur le chiffre d'affaires mondial."
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Bonus unique en diamants (Carat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: "Ce bonus vous est versé pour chaque nouveau Solution Plan souscrit jusqu'au 3ème niveau. Vous débloquez les différents niveaux avec des qualifications très faibles.",
    total: "Jusqu'à 18% d'Unilevel Bonus",
    levels: [
      {
        level: 'Niveau 1',
        value: '10%',
        qual: 'dès le début',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Niveau 2',
        value: '5%',
        qual: 'dès le rang Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Niveau 3',
        value: '3%',
        qual: 'dès le rang Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: "À partir du rang Sapphire, vous êtes qualifié pour notre plan d'Infinity Bonus. Vous recevez 3% de bonus. À chaque nouveau rang, des pourcentages supplémentaires s'ajoutent. Si un Partner de votre équipe est également qualifié, vous recevez la différence de rang à rang.",
    exampleTitle: 'Exemple',
    exampleRows: [
      { label: 'Vous êtes Blue Diamond', value: '12%' },
      { label: 'Votre Partner est Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Votre Infinity Bonus', value: '9%' },
    totalNote: "Total jusqu'à 24% d'Infinity Bonus sur tous les Solution Plans souscrits dans votre équipe — profondeur infinie.",
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: "Avec ce bonus, vous profitez de la réussite de votre équipe. Vous recevez un Matching Bonus de 5% sur l'Infinity Bonus de vos Partners — et ce jusqu'au 5ème niveau de votre équipe.",
    note: "Sur tous les paiements d'Infinity Bonus dans votre équipe – jusqu'au 5ème niveau. Dès le début – SANS qualification.",
    levels: [
      { level: 'Niveau 1', value: '5%' },
      { level: 'Niveau 2', value: '5%' },
      { level: 'Niveau 3', value: '5%' },
      { level: 'Niveau 4', value: '5%' },
      { level: 'Niveau 5', value: '5%' }
    ],
    totalPrefix: "Total jusqu'à",
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: "3% du chiffre d'affaires mondial sont versés à parts égales dans 3 pools différents. En atteignant certains rangs, vous vous qualifiez pour chaque pool individuel.",
    forever: 'Atteint une fois – participation pour TOUJOURS !',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'dès Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'dès Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'dès Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Total',
    totalValue: '3%',
    totalSuffix: "du chiffre d'affaires mondial"
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: "À partir du rang Diamond, vous recevez un Rang Bonus. Celui-ci est versé en diamants (Carat). Il s'agit d'un bonus unique.",
    highlight: "Diamants (Carat) d'une valeur totale de",
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Niveaux de carrière',
    title: 'Niveaux de carrière',
    sub: "Pour atteindre les niveaux de carrière respectifs, le chiffre d'affaires historique total (HG) est pris en compte. À partir du stade Sapphire, celui-ci doit être réparti sur plusieurs équipes. Pour atteindre Ruby ou plus, vous avez besoin d'au moins deux Partners directs avec un Solution Plan.",
    forever: 'Atteint une fois – confirmé pour TOUJOURS !',
    footnote: "HV = Chiffre d'affaires historique total.",
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 Partners dir.', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Lancez-vous avec nous',
    title: "Le bon moment, c'est maintenant.",
    body: "Ce modèle d'affaires établit de nouveaux standards et réunit tous les facteurs de succès pour une activité durable et prospère à long terme. Inscrivez-vous aujourd'hui, choisissez votre plan Solution et saisissez cette opportunité d'affaires unique.",
    hint: "Parlez à la personne qui vous a invité à cette présentation — elle a un lien d'inscription pour vous.",
    formName: 'Nom',
    formEmail: 'E-mail',
    formPhone: 'Téléphone',
    formSubmit: 'Prendre contact',
    success: 'Merci — nous vous recontacterons discrètement et personnellement.',
    callCta: 'Appeler',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Avis juridique & Disclaimer',
    disclaimer: "Cette présentation sert uniquement à titre d'information et ne constitue pas un conseil financier, d'investissement ou fiscal. STIG ROCK n'est pas un produit financier, mais se réfère à des diamants naturels en tant qu'actifs tangibles. Aucune garantie n'est donnée quant à l'évolution de la valeur, aux gains ou aux rendements. Les performances passées ne sont pas une indication des résultats futurs. Tous les calculs présentés en relation avec les commissions sont purement exemplaires et ne constituent pas non plus une garantie. Sous réserve de modifications du contenu — traduction libre (pas de traduction officielle).",
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Tous droits réservés.',
    version: 'Version : DS-12-2025 V3'
  },
  misc: { next: 'Section suivante' }
};

export default fr;
